<template>
  <div :key="form.componentKey">
    <div
      v-for="(template, index) in form.available_config_templates"
      :key="index"
    >
      <config-editor
        v-if="check(template.replacer_name)"
        :replacer-name="template.replacer_name"
        :title="getTitleByReplacerName(template.replacer_name)"
        :model-parameters="form.model_parameters"
        :available-config-templates="form.available_config_templates"
        :on-update-parameter-values="onUpdateParameterValues"
        :on-remove-editor="onRemoveEditor"
      />
    </div>
  </div>
</template>

<script>
import ConfigEditor from "./ConfigEditor";

export default {
  name: "ConfigEditorList",
  components: { ConfigEditor },
  props: {
    parsedReplacers: {
      type: Object,
      default: function() {},
    },
    availableConfigTemplates: {
      type: Object,
      default: function() {},
    },
    modelParameters: {
      type: Object,
      default: function() {},
    },
    modelParametersForSend: {
      type: Array,
      default: function() {},
    },
  },
  data() {
    return {
      form: {
        available_config_templates: this.availableConfigTemplates,
        model_parameters: this.modelParameters,
        model_parameters_for_send: this.modelParametersForSend,
        //Используется для ререндера едиторов
        componentKey: 0,
      },
    };
  },
  created() {
    this.onUpdateParameterValues()
  },
  methods: {
    refreshForm() {
      this.form = {
        available_config_templates: this.availableConfigTemplates,
        model_parameters: this.modelParameters,
        model_parameters_for_send: this.modelParametersForSend,
        componentKey: this.form.componentKey + 1,
      }
    },
    getTitleByReplacerName(replacerName) {
      let title = null;
      for (let i in this.form.available_config_templates) {
        if (this.form.available_config_templates[i].replacer_name === replacerName) {
          title = this.form.available_config_templates[i].description;
          break;
        }
      }
      return title;
    },
    onUpdateParameterValues(data) {
      if (data !== undefined){
        let id_camera_config = this.getIdCameraConfigParameter(data.replacer);
        let index = this.getIndexOfModelParameter(id_camera_config);
        this.form.model_parameters_for_send[index] = {
          id_camera_config_parameter: id_camera_config,
          current_value: data.current_value.value,
          is_client_editable: data.is_client_editable,
        };
      }
    },
    onRemoveEditor(data) {
      let id_camera_config = this.getIdCameraConfigParameter(data.replacer);
      let index = this.getIndexOfModelParameter(id_camera_config);
      //Vue не реагирует на изменение массива сплайсом,
      //если данные из этого массива воткнуть в тэмплейт всё сломается
      this.form.model_parameters_for_send.splice(index, 1);
    },
    getIdCameraConfigParameter(replacerName) {
      let id_config_parameter = -1;
      for (let i in this.form.available_config_templates) {
        if (this.form.available_config_templates[i].replacer_name === replacerName) {
          id_config_parameter = this.form.available_config_templates[i].id_camera_config_parameter;
          break;
        }
      }
      return id_config_parameter;
    },
    getIndexOfModelParameter(id_camera_config) {
      let index = -1;
      index = this.form.model_parameters_for_send.findIndex(
        (e) => e.id_camera_config_parameter === id_camera_config
      )
      if (index === -1) {
        index = this.form.model_parameters_for_send.length;
      }
      return index;
    },

    check(replacer_name) {
      const result = Object.values(this.parsedReplacers).find(el => el === replacer_name)
      return result !== undefined
    },
  },
};
</script>

<style scoped>

</style>
